import React from 'react'

/**
 * Common renderTabBar function for AdminSubHeader components
 * Sets tabIndex to 0 for active tab and -1 for inactive tabs
 * @param {string} activeTab - The key of the currently active submenu
 * @returns {function} A renderTabBar function compatible with antd Tabs
 */
export const createTabBarRenderer = (activeTab) => (props, DefaultTabBar) => (
  <DefaultTabBar {...props}>
    {(node) => {
      const tabElement = React.cloneElement(node, {
        ...(activeTab === node.key ? { tabIndex: 0 } : { tabIndex: -1 }),
      })
      return tabElement
    }}
  </DefaultTabBar>
)

export const USER_SUB_HEADER_FROM = 'user-sub-header'
export const ADMINISTRATOR_SUB_HEADER_FROM = 'administrator-sub-header'
export const GROUP_SUB_HEADER_FROM = 'group-sub-header'
export const SETTING_SUB_HEADER_FROM = 'setting-sub-header'
export const CONTENT_SUB_HEADER_FROM = 'content-sub-header'
